// extracted by mini-css-extract-plugin
module.exports = {"actionsWrapper":"TraceabilityTable_actionsWrapper__2r-eu","link":"TraceabilityTable_link__29jhs"};